import './ResponseEdition.css';
import Dropdown from '../../../../../../components/UI/DropDown/DropDown';
import StatementResponseType from '/src/features/editor/data/constant/types/StatementResponseType';
import TextInput from '/src/components/UI/TextField/TextInput';
import Button from '/src/components/UI/Button/Button';
import { useState } from 'react';
import { useModal } from '@ebay/nice-modal-react';
import ReactTextareaAutosize from 'react-textarea-autosize';
import InputBox from "/src/components/UI/InputBox/InputBox"
function ResponseEdition({ type, content, index, onClose, isCustomResponse, is_not_link }) {

    var statementResponseType = [...StatementResponseType]

    const [typeValue, setTypeValue] = useState(type ? type : 'quick');
    const data = { quick: '', custom: 'Custom response', raw: '' };
    if (type != undefined) {
        data[typeValue] = content;
    }

    if (type != 'custom' && isCustomResponse) {
        statementResponseType.splice(1, 1);
    }

    const [contentValue, setContentValue] = useState(data);
    const [isLinked, setIsLinked] = useState(is_not_link != null ? !is_not_link : true);
    const modal = useModal()

    const onClick = () => {
        modal.resolve({ index, data: { type: typeValue, content: contentValue[typeValue], is_not_link : !isLinked } });
        return onClose();
    }

    const setContentValueKey = (key, value) => {
        setContentValue({ ...contentValue, [key]: value })
    }

    const disableSpellCheck = (ref) => {
        if (!ref) {
            return;
        }
        ref.spellcheck = false
    }


    const checkValidation = (value) => {
        return value.trim().length == 0;
    }

    const classNameDropdown = type != undefined && isCustomResponse ? 'dropdown type_responses disabled' : 'dropdown type_responses';

    return (
        <div className='response_modal'>
            <label className='title'>{type ? 'Update a response' : 'Create a Response'}</label>
            <div className='area-edit'>
                <div className='grid-row'>
                    <label className="dropdown_title">Type of Response : </label>
                    <div className='dropdown_container'>
                        <Dropdown choices={statementResponseType} setValue={(name, value) => setTypeValue(value)} defaultChoice={typeValue} width="200px" className={classNameDropdown} />
                    </div>
                    {
                        typeValue == "raw" && 
                        <>
                            <label className="dropdown_title"> Trigger next action : </label>
                            <div className='raw_response_checkbox'>
                                <InputBox id="session_active" setValue={(name, checked) => setIsLinked(checked)} check={isLinked} ></InputBox>
                            </div>
                        </>
                    }
                </div>

                {typeValue != 'raw' ?
                    <div className='grid-row'>
                        <label className="dropdown_title" style={{ marginLeft: 68 }}>Content : </label>
                        <div className='dropdown_container'>
                            <TextInput className="input full-width" value={contentValue[typeValue]} onChange={(e) => setContentValueKey(typeValue, e.target.value)} />
                        </div>
                    </div>
                    : ''}
                <div className='response_content' style={{ justifyItems: 'center', display: 'flex', flexDirection: 'column' }}>
                    {typeValue == 'raw' ? <ReactTextareaAutosize ref={(ref) => disableSpellCheck(ref)} value={contentValue[typeValue]} onChange={(e) => setContentValueKey(typeValue, e.target.value)} className="input editor-input title_input" minRows={4} /> : ''}
                </div>
            </div>
            <Button label="Confirm" disabled={checkValidation(contentValue[typeValue])} onClick={onClick} />
        </div>
    )
}

export default ResponseEdition